// extracted by mini-css-extract-plugin
export var layoutContainer = "_cx-0";
export var layoutContainerNoRounding = "_cx-6";
export var layoutContainerOpen = "_cx-5";
export var layoutContainerResizing = "_cx-1";
export var mainContent = "_cx-2";
export var resizeDivider = "_cx-3";
export var slidePanel = "_cx-4";